export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./JerseyModal.vue?vue&type=template&id=1c77f19d&"


//////////////////
// WEBPACK FOOTER
// ./src/components/JerseyModal.vue?vue&type=template&id=1c77f19d&
// module id = 544
// module chunks = 0